import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { ConfigService } from "../../_services/config.service"
import { BehaviorSubject, Observable } from "rxjs"
import { map, tap } from "rxjs/operators"
import { Collaborator } from "../../_models/incident/wfdssCase/collaborator"
import { AuthenticationService } from "./authentication/authentication.service"
import { UserRoleType } from 'src/app/_models/user/userRoleType';
@Injectable({
	providedIn: "root",
})
export class CollaboratorsFacadeService {
	private readonly baseUrl = this.environment.caseApi.baseUrl
	private readonly cases = this.baseUrl + this.environment.caseApi.cases
	private readonly collaboratorsUrl = this.environment.caseApi.collaborators
	private _collaboratorsSubject: BehaviorSubject<Collaborator[]>
	public collaborators$: Observable<Collaborator[]>
	public leadCollaborator$: Observable<Collaborator>
	public analystCollaborators$: Observable<Collaborator[]>
	public approverCollaborators$: Observable<Collaborator[]>
	public regularCollaborators$: Observable<Collaborator[]>
	public isInitiated: Observable<boolean>

	constructor(private http: HttpClient, private authenticationService: AuthenticationService, private environment: ConfigService) {
		this._collaboratorsSubject = new BehaviorSubject<Collaborator[]>([])
		this.collaborators$ = this._collaboratorsSubject.asObservable()
		const populatedCollaborators = this.collaborators$.pipe(
			map((collborators) => {
				if (!collborators) {
					return null
				}
				if (!(collborators?.length > 0)) {
					return null
				}
				return collborators
			})
		)
		// this.leadCollaborator$ = populatedCollaborators
		this.leadCollaborator$ = populatedCollaborators.pipe(
			map((collabs) => {
				if (collabs == null) { return null }
				return collabs.find((collaborator) => {
					return collaborator?.isLead == true
				})

			}),
		)
		this.analystCollaborators$ = populatedCollaborators.pipe(
			map((collabs) => {
				if (collabs == null) { return null }

				return collabs.filter((collaborator) => {
					return collaborator.user.role.roleType === "ANALYST"
				})

			}),
		)
		this.approverCollaborators$ = populatedCollaborators.pipe(
			map((collabs) => {
				if (collabs == null) { return null }

				return collabs.filter((collaborator) => {
					return collaborator.isApprover
				})

			}),
		)
		this.regularCollaborators$ = populatedCollaborators.pipe(
			map((collabs) => {
				if (collabs == null) { return null }

				let regularCollaborators = collabs.filter((collaborator) => {
					!collaborator.isApprover && !collaborator.isLead && collaborator.user.role.roleType !== "ANALYST"
				})
				if (regularCollaborators.length == 0) {
					return null
				} else {
					return regularCollaborators
				}

			}),
		)
		this.isInitiated = populatedCollaborators.pipe(
			map((collaborators) => {
				if (!collaborators) {
					return false
				} else if (collaborators?.length > 0) {
					return true
				} else {
					return false
				}
			}),
		)
	}
	/**@description PUT collaborators for a given case id. Populates collaborator variables with the returned value/  */
	putCollaborators(caseId: number, collaborators: Collaborator[]) {
		return this.http.put<Collaborator[]>(this.cases + `/${caseId}${this.collaboratorsUrl}`, collaborators).pipe(
			tap((collaboratorPutResponse) => {
				this._collaboratorsSubject.next(collaboratorPutResponse)
			}),
		)
	}
	/**@description GET collaborators for a given case id. Populates collaborator variables with the returned value/  */
	getCollaborators(caseId: number) {
		return this.http.get<Collaborator[]>(this.cases + `/${caseId}${this.collaboratorsUrl}`).pipe(
			tap((collaboratorGetResponse) => {
				this._collaboratorsSubject.next(collaboratorGetResponse)
			}),
		)
	}
	/**@description set collaborators (and all member variables derived from collaborators in this service) without making a network call to the backend*/
	setCollaborators(collaborators: Collaborator[]) {
		this._collaboratorsSubject.next(collaborators)
	}
	/**
	 * @description gets the value of the collaborators array subject. 
	 * @warning If you're getting unexpected behavior while using this inside subscriptions, you probably have a race condition. 
	 * Combine the collaborators$ observable with your observable using rxjs pipes and operators instead.*/
	getCollaboratorsValue() {
		return this._collaboratorsSubject.getValue()
	}

	isUserCollaborator() {
		const loggedInUser = this.authenticationService.currentUser;
		const collaborators = this.getCollaboratorsValue();
		const userRoles: String[] = [UserRoleType.SUPPORT, UserRoleType.GA_EDITOR, UserRoleType.ANALYST];
		const collabUser = collaborators.filter((collaborator) => {
			return collaborator?.user?.userId === loggedInUser?.userId;
		});
		if (userRoles.includes(loggedInUser?.role?.roleType) || (collabUser?.length && loggedInUser?.role?.roleType === UserRoleType.INCIDENT_EDITOR)) {
			return true;
		} else {
			return false;
		}
	}
}
